// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorAvailableVendors = (client) => ({
    /**
     * `GET /vendor/available-vendors`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAvailableVendorsList
     * @source apps/backend/src/api/vendor/available-vendors/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/available-vendors", { method: "GET", query, headers }),
});
//# sourceMappingURL=available-vendors.js.map